import {ChangeDetectionStrategy, Component, EventEmitter, OnInit} from '@angular/core';
import {
  BaseComponent,
  CartProduct,
  CartRemoteService,
  formatPriceNumber
} from 'compob2b-libs';
import {NbButtonModule, NbCardModule, NbSpinnerModule, NbWindowRef} from '@nebular/theme';
import {takeUntil, tap} from 'rxjs/operators';
import {FormsModule} from '@angular/forms';
import {
  SpecificationImportListComponent
} from '../../orders/specifications-module/components/import-list/import-list.component';
import {RouterLink} from "@angular/router";

@Component({
  templateUrl: './import-to-cart.component.html',
  styleUrls: ['./import-to-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, SpecificationImportListComponent, NbCardModule, NbButtonModule, NbSpinnerModule, formatPriceNumber, RouterLink]
})

export class ImportToCartComponent extends BaseComponent implements OnInit {
  cartProductList: CartProduct[];
  existsProductList: CartProduct[] = [];
  absentProductList: CartProduct[] = [];
  requestedProductList: CartProduct[] = [];
  selected = new Set<number>();

  onSubmitProducts: EventEmitter<boolean>;
  totalCost = 0;
  totalCostVat = 0;
  submitted = false;

  constructor(
    private readonly windowRef: NbWindowRef,
    private readonly cartService: CartRemoteService) {
    super();
  }

  ngOnInit(): void {
    this.existsProductList = this.cartProductList.filter(product => (product.productId !== null && !this.isRequestedProduct(product)));
    this.requestedProductList = this.cartProductList.filter(product => this.isRequestedProduct(product))
    this.absentProductList = this.cartProductList.filter(product => (product.productId === null));
    this.countTotalCost();
  }

  delete(index: number): void {
    this.cartProductList.splice(index, 1);
    this.cartProductList = [...this.cartProductList];
    this.ngOnInit();
    this.cdr.detectChanges();
  }

  private countTotalCost(): void {
    let totalCost = 0;
    let totalCostVAT = 0;

    this.existsProductList.forEach(item => {
      const price = item.commercePrice?.price ?? item.price;
      const priceVAT = item.commercePrice?.priceNds ?? item.priceNds;
      const multiplicity = Math.max(item.multiplicityOrder ?? 1, 1);
      const amount = Math.ceil(item.amount / multiplicity) * multiplicity || 1;

      totalCost += price * amount;
      totalCostVAT += priceVAT * amount;
    });

    this.totalCost = totalCost;
    this.totalCostVat = totalCostVAT;
  }

  send() {
    if (this.selected.size > 0) {
      const selectedProduct: CartProduct[] = [];
      this.selected.forEach(item => selectedProduct.push(this.existsProductList[item]));

      this.submitted = true;
      this.cartService.addList(selectedProduct).pipe(
        tap(_ => this.handlerResponse()),
        takeUntil(this.unsubscribe)
      ).subscribe();
    }
  }

  private handlerResponse() {
    this.submitted = false;
    this.onSubmitProducts.emit(true);
    this.close();
  }

  close(): void {
    this.windowRef.close();
  }

  select($event: Set<number>) {
    this.selected = $event;
    this.cdr.detectChanges();
  }

  isRequestedProduct(product: CartProduct) : boolean {
    const oneCondition = product.sync && (!product.commercePrice || 0 === product.commercePrice?.price);
    const twoCondition = !product.sync && product.productCode !== null && 0 < product.productCode.length;
    return oneCondition || twoCondition;
  }

}
